import TableCellLink from "ds/components/Table/Row/CellLink";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScansListItem } from "../../../types";

const ScansTableNameCell = ({ item: scan, ...cellProps }: TableSimpleCellProps<ScansListItem>) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellLink href={`/resources/scans/${scan.id}/resources`}>{scan.name}</TableCellLink>
  </TableSimpleCell>
);

export default ScansTableNameCell;
